/*
 * @Author: shiguang
 * @Date: 2023-02-23 15:13:00
 * @LastEditTime: 2024-06-20 16:36:26
 * @LastEditors: yusha
 * @Description: react-i18next-config
 */
import { createContext } from 'react';
import queryString from 'query-string';
import extractConfig from '@/i18n/locales/extractConfig.json';
import jp from '@/i18n/locales/ja_JP.json';
import kr from '@/i18n/locales/ko_KR.json';
import zh from '@/i18n/locales/zh_CN.json';
import en from '@/i18n/locales/en_GB.json';
import { SiteLocalKey } from '@/config/request/login';

const qs = queryString.parse(window.location.search);

/**
 * 国家及货币单位
 */
export enum Site {
	/**
	 * 日本站
	 */
	JA = 'JapanStation',
	/**
	 * 韩国站
	 */
	KO = 'KoreaStation',
	/**
	 * 英国站
	 */
	EN = 'UkStation'
}

export const lang: string | undefined = (() => {
	let lang = qs?.lang as string | undefined;
	lang = lang ? lang.toLocaleLowerCase() : undefined;

	if (lang === 'ja' || lang === 'jp') {
		lang = 'ja';
	}

	return lang;
})();

/** 本地语言文件枚举，从query中lang的语言类型 */
export enum Local {
	ZH = 'zh',
	/** 日文 */
	JA = 'ja',
	/** 韩文 */
	KO = 'ko',
	/** 英文 */
	EN = 'en'
}

/** 语言枚举 */
export enum Lang {
	zh_CN = 'zh_CN',
	/** 日文 */
	ja_JP = 'ja_JP',
	/** 韩文 */
	ko_KR = 'ko_KR',
	/** 英文 */
	en_GB = 'en_GB'
}

export const getLocalByLang = (() => {
	const getLocalByLangMap = new Map();
	getLocalByLangMap.set(Lang.zh_CN, Local.ZH);
	getLocalByLangMap.set(Lang.ja_JP, Local.JA);
	getLocalByLangMap.set(Lang.ko_KR, Local.KO);
	getLocalByLangMap.set(Lang.en_GB, Local.EN);

	return getLocalByLangMap;
})();

// url query 获取带过来的语言
const getQuerylang = (): Lang => {
	const query = queryString.parse(window.location.search) as { lang: Local };
	return {
		[Local.ZH]: Lang.zh_CN,
		[Local.JA]: Lang.ja_JP,
		[Local.KO]: Lang.ko_KR
		// [Local.EN]: Lang.en_GB
	}[query.lang];
};

const langArr = [Lang.zh_CN, Lang.en_GB, Lang.ja_JP, Lang.ko_KR];

/** 从缓存中获取当前的语言 */
const getOldLocalLang = () => {
	const langJson = localStorage.getItem(SiteLocalKey);
	const lang = langJson ? JSON.parse(langJson)?.val ?? Local.ZH : Local.ZH;
	if (langArr.includes(lang as Lang)) {
		return lang;
	}

	return (
		{
			[Local.ZH]: Lang.zh_CN,
			[Local.JA]: Lang.ja_JP,
			[Local.KO]: Lang.ko_KR,
			[Local.EN]: Lang.en_GB
		}[lang] || Lang.ja_JP
	);
};

/** 初始化获取当前的语言 */
export const getLang = () => {
	// const langs = ['zh', 'ja', 'ko', 'en', 'ko', 'th']
	const queryLang = getQuerylang();
	if (queryLang) {
		localStorage.setItem('lang', queryLang);
		const _queryLang = {
			[Lang.zh_CN]: Local.ZH,
			[Lang.ja_JP]: Local.JA,
			[Lang.ko_KR]: Local.KO,
			[Lang.en_GB]: Local.EN
		}[queryLang];

		localStorage.setItem('__lang__', _queryLang);
		// return Local.JA;
		return queryLang;
	}

	const oldLocalLang = getOldLocalLang();
	console.log(888888, oldLocalLang);
	if (oldLocalLang) {
		localStorage.setItem('__lang__', oldLocalLang);
		return oldLocalLang;
	}
	const lang = localStorage.getItem('__lang__');
	if (lang) {
		return lang;
	}
	localStorage.setItem('__lang__', Lang.ja_JP);
	return Lang.ja_JP;
};

/**
 * 获取站点信息
 * @returns
 */
export const getStationCode = () => {
	return Site[initLang] || Site.JA;
};

const initLang = getLang();
export const LocalContext = createContext(initLang);

window._$m = {
	t: (text: string) => {
		const { pages, common } = extractConfig;
		const urlPathname = window.location.pathname;
		const lang = Lang.ja_JP;
		const item = pages
			.map(
				(item: {
					path: string;
					urlPathname: string;
					name: string;
					linkTo: any;
				}) => {
					return {
						...item,
						linkTo: [...(item.linkTo ?? []), item.path]
					};
				}
			)
			.find((item) => item.urlPathname === urlPathname)!;

		const allTranslateJson = window.g_locales
			? window.g_locales[lang]
			: window._$m[lang] ?? {};
		const commonTranslates = common.reduce((pre, cur: any) => {
			return {
				...pre,
				...(allTranslateJson?.[cur.path] ?? {})
			};
		}, {} as any);
		const linkTo = item?.linkTo ?? [];
		const getConfig = linkTo.reduce((pre, cur) => {
			return {
				...commonTranslates,
				...pre,
				...allTranslateJson?.[cur]
			};
		}, {} as any);
		return ['', undefined].includes(getConfig[text])
			? text
			: getConfig[text];
	},
	[Lang.ja_JP]: jp,
	[Lang.ko_KR]: kr,
	[Lang.en_GB]: en,
	[Lang.zh_CN]: zh
};
